import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/icon-arrow-down.svg';
import { HEADER_BUTTON_HEIGHT, LARGE_BUTTON_WIDTH } from '../../utils/styled/dimensions';

export const Components = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 32px;
    min-width: fit-content;
  `,
  HorizontalHeaderWrapper: styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 24px;
  `,
  QuestionTypeWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    justify-content: flex-start;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.boxShadows};
    padding: 24px 16px;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  SearchBarChildrenWrapper: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 24px;
    margin-left: 8px;
    height: 100%;
  `,
  SearchBarSeparator: styled.div`
    width: 1px;
    height: 38px;
    background-color: ${AppCSS.colors.greys.light};
  `,
  FiltersWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${LARGE_BUTTON_WIDTH}px;
    min-width: ${LARGE_BUTTON_WIDTH}px;
    height: ${HEADER_BUTTON_HEIGHT}px;
    min-height: ${HEADER_BUTTON_HEIGHT}px;
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: transparent;
    overflow: hidden;
    width: 100%;
    padding: 12px;
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    flex: 1;
  `,
};
